import React from 'react';
import Chip from '@material-ui/core/Chip';
import useStatusStyles from '../../hooks/objective/status/useStyle';

const DevelopmentStatusChip = ({ label, developmentStatus }) => {
  const classes = useStatusStyles();

  return (
    <Chip
      label={ label }
      className={ `${classes[developmentStatus]} ${classes.button}` }
    />
  );
};

export default DevelopmentStatusChip
;